import React from 'react';
import { Col, FormGroup, Checkbox } from 'react-bootstrap';

class CompletionFilters extends React.Component {
  completionStatus = [
    {'Complete': 'complete'},
    {'Incomplete': 'incomplete'},
    {'Partially Complete': 'partiallyComplete'}
  ]
  updateCompletion(e){
    const status = e.target.name;
    const checked = e.target.checked;

    if(checked){
      this.props.addCompletion(status);
    } else {
      this.props.removeCompletion(status);
    }
  }
  render(){
    const self = this;
    return(
      <Col md={6}>
        <label className="control-label">Completion Status</label>
        <FormGroup>
          {
            this.completionStatus.map(function(status){
              const name = Object.keys(status)[0];
              const key = status[name];
              return(
                <Checkbox
                  key={key}
                  name={key}
                  checked={self.props.selectedCompletion.includes(key)}
                  inline
                  onChange={self.updateCompletion.bind(self)}
                >
                  {name}
                </Checkbox>
              )
            })
          }
        </FormGroup>
      </Col>
    )
  }
}

export default CompletionFilters;
